import React, { useEffect, useRef } from 'react';

//components
import SearchControls from './searchControls';
import SearchResults from './searchResults';

//hooks
import useSearch from './hooks/useSearch';



const SearchContainer = ({closeSearch, appName}:{closeSearch: () => void, appName: string}) => {

    const searchRef = useRef<any>();
    const { searchResults, totalResults, isLoading, getResults, lastFilters, searchCompleted, setLastFilters, getMore, currentSkip, clearFilters, setLastSearchTerms} = useSearch();

    useEffect(() => {
        if(document.getElementById('mainbody')){
            (document.getElementById('mainbody') as HTMLDivElement).style.overflow = 'hidden'
        }
        
        function handleClickOutside(event: Event) {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                closeSearch();
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            if(document.getElementById('mainbody')){
                (document.getElementById('mainbody') as HTMLDivElement).style.overflow = 'initial'
            }
        };
    }, [])

    return <div className='search-background'>
        <section ref={searchRef} className='search'>
            <SearchControls
                getResults={getResults}
                totalResults={totalResults}
                defaultFilters={lastFilters}
                setFilters={setLastFilters}
                appName={appName}
                setLastSearchTerms={setLastSearchTerms}
            />
            {lastFilters.searchTerm && 
                <SearchResults
                    filters={lastFilters}
                    clearFilters={clearFilters}
                    results={searchResults}
                    isLoading={isLoading}
                    searchCompleted={searchCompleted}
                    hasMore={!!currentSkip}
                    getMore={getMore}
                />
            }
        </section>
       
    </div>
}

export default SearchContainer